import React from "react";
import styled from "styled-components/macro";
import { device, toRem } from "theme/Breakpoints";
import Area from "assets/images/ProductDetails/area.svg";
import Fan from "assets/images/ProductDetails/fan.svg";
import Waranty from "assets/images/ProductDetails/waranty.svg";
import AirConditioner from "assets/images/ProductDetails/air-conditioner.svg";
import { colors } from "theme/Theme";
import { Product } from "features/ProductReel/types";
import { DefaultText } from "theme/GlobalElements";

interface TechnicalDescriptionProps {
  fetchedProduct: Product;
}

interface TechDesc {
  svgImg: any;
  title: string;
  content: string;
}

const TechnicalDescription: React.FC<TechnicalDescriptionProps> = ({
  fetchedProduct,
}) => {
  const config: TechDesc[] = [
    {
      svgImg: AirConditioner,
      title: fetchedProduct.tech_specs.data.common_specs.data.type?.title,
      content: fetchedProduct.tech_specs.data.common_specs.data.type?.value,
    },
    {
      svgImg: Fan,
      title: fetchedProduct.tech_specs.data.common_specs.data.power_btu?.title,
      content:
        fetchedProduct.tech_specs.data.common_specs.data.power_btu?.value,
    },
    {
      svgImg: Area,
      title: fetchedProduct.tech_specs.data.common_specs.data.quadrature?.title,
      content:
        fetchedProduct.tech_specs.data.common_specs.data.quadrature?.value,
    },
    {
      svgImg: Waranty,
      title: fetchedProduct.tech_specs.data.common_specs.data.waranty?.title,
      content: fetchedProduct.tech_specs.data.common_specs.data.waranty?.value,
    },
  ];

  return (
    <TechnicalDescriptionContainer>
      {config.map((item) => {
        if (item.content && item.content !== "-1") {
          return (
            <InfoItem key={item.title}>
              <SVGImg src={item.svgImg} />
              <InfoContainer>
                <InfoTitle className="text-xs">{item.title}</InfoTitle>
                <Info className="text-sm">{item.content}</Info>
              </InfoContainer>
            </InfoItem>
          );
        }
      })}
    </TechnicalDescriptionContainer>
  );
};

const InfoItem = styled.div`
  flex: 0 100%;
  display: flex;
  flex-flow: row nowrap;

  @media only screen and (${device.tablet}) {
    flex: 0 50%;
  }

  @media only screen and (${device.laptopL}) {
    flex: 0 33%;
  }
`;

const TechnicalDescriptionContainer = styled.div`
  flex: 1;
  display: grid;
  grid-template-rows: auto;
  grid-template-columns: repeat(2, 1fr);
  grid-row-gap: 10px;
  grid-column-gap: 10px;
  justify-items: flex-start;
  margin-bottom: 20px;

  @media only screen and (${device.tablet}) {
    grid-template-rows: auto;
    grid-template-columns: 1fr 1fr;
    margin-bottom: 0;
  }

  @media only screen and (${device.laptop}) {
    grid-row-gap: 20px;
    grid-column-gap: 20px;
  }

  @media only screen and (${device.laptopL}) {
    flex: 2;
    margin: 20px 0;
  }
`;

const SVGImg = styled.img`
  width: 36px;
  height: 36px;
  margin-right: 10px;
  filter: invert(56%) sepia(26%) saturate(4445%) hue-rotate(188deg)
    brightness(112%) contrast(104%);
  @media only screen and (${device.tablet}) {
    margin-right: 10px;
    width: 36px;
    height: 36px;
  }
`;
const InfoContainer = styled.div`
  flex: 1;
  display: flex;
  flex-flow: column nowrap;
`;
const InfoTitle = styled(DefaultText)`
  color: ${colors.dark_gray};
`;
const Info = styled(DefaultText)`
  font-weight: 500;
  color: black;
`;

export default TechnicalDescription;
